import React from 'react';
import { X, Building2 } from 'lucide-react';
import { MOV_FIT_UNIDADES } from 'features/dp/services/dpService';

export default function SelecionarUnidadeModal({ onSelecionar, onCancelar }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-[color:var(--surface)] rounded-2xl shadow-2xl w-full max-w-sm flex flex-col">

        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-[color:var(--border)]">
          <div>
            <h2 className="text-lg font-bold text-[color:var(--text)]">MOV Fit — Selecionar Unidade</h2>
            <p className="text-xs text-[color:var(--text-muted)] mt-0.5">Escolha a unidade para importar funcionários</p>
          </div>
          <button onClick={onCancelar} className="text-[color:var(--text-muted)] hover:text-[color:var(--text)] transition-colors">
            <X size={20} />
          </button>
        </div>

        {/* Unidades */}
        <div className="p-4 space-y-2">
          {MOV_FIT_UNIDADES.map((unidade) => (
            <button
              key={unidade.id}
              onClick={() => onSelecionar(unidade)}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-xl border border-[color:var(--border)] bg-[color:var(--surface)] hover:bg-teal-50 hover:border-teal-400 dark:hover:bg-teal-900/20 transition-colors text-left group"
            >
              <div className="p-2 rounded-lg bg-[color:var(--surface-muted)] group-hover:bg-teal-100 dark:group-hover:bg-teal-900/30 transition-colors">
                <Building2 size={18} className="text-[color:var(--text-muted)] group-hover:text-teal-600 transition-colors" />
              </div>
              <span className="font-medium text-[color:var(--text)] group-hover:text-teal-700 dark:group-hover:text-teal-400 transition-colors">
                {unidade.label}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
